"use strict";
/** @module utils */
Object.defineProperty(exports, "__esModule", { value: true });
exports.range = range;
exports.nullIfBlank = nullIfBlank;
exports.enumNames = enumNames;
exports.enumItems = enumItems;
exports.getEnumDropdowns = getEnumDropdowns;
exports.stringIsHtml = stringIsHtml;
exports.parseFloatOrNull = parseFloatOrNull;
exports.parseIntOrNull = parseIntOrNull;
exports.str2e = str2e;
exports.getPassword = getPassword;
exports.parseNumberStatus = parseNumberStatus;
exports.arraysEqual = arraysEqual;
exports.compareDates = compareDates;
exports.download = download;
exports.downloadType = downloadType;
var format_1 = require("./format");
var ReportMixin_1 = require("../ManagementApi/ReportMixin");
/**
 * Create range of numbers.
 * @param start Start if stop also given, otherwise stop.
 * @param stop
 * @param step Steps between numbers in range.
 * @return Array of numbers in range.
 */
function range(start, stop, step) {
    if (stop == undefined) {
        stop = start;
        start = 0;
    }
    if (step == undefined) {
        step = 1;
    }
    if ((step > 0 && start >= stop) || (step < 0 && start <= stop)) {
        return [];
    }
    var result = [];
    for (var i = start; step > 0 ? i < stop : i > stop; i += step) {
        result.push(i);
    }
    return result;
}
/**
 * Format string to null if blank.
 * @param s String to check if blank.
 * @return String or null.
 */
function nullIfBlank(s) {
    return s == '' || s == undefined ? null : s;
}
/**
 * Get enum names.
 * @param e Enum
 * @return Array of enum keys.
 */
function enumNames(e) {
    return Object.keys(e).filter(function (key) { return !isNaN(Number(e[key])); });
}
/**
 * Get enum items.
 * @param e
 * @return Array of enum items.
 */
function enumItems(e) {
    return enumNames(e).map(function (n) { return ({
        name: n,
        value: e[n],
    }); });
}
/**
 * Get enum dropdowns.
 * @param x any
 * @param titleCase boolean
 * @return any
 */
function getEnumDropdowns(x, titleCase) {
    if (titleCase === void 0) { titleCase = true; }
    return enumItems(x).map(function (v) { return ({
        key: v.name,
        value: x[v.value],
        text: titleCase ? (0, format_1.toTitleCase)(v.name) : v.name,
    }); });
}
/**
 * stringIsHtml
 * @param s
 */
function stringIsHtml(s) {
    return s.match(/<html>/i) != null;
}
/**
 * parseFloatOrNull
 * @param value
 */
function parseFloatOrNull(value) {
    var result = parseFloat(value || '');
    return !isNaN(result) ? result : null;
}
/**
 * parseIntOrNull
 * @param value
 */
function parseIntOrNull(value) {
    var result = parseInt(value || '', 10);
    return !isNaN(result) ? result : null;
}
/**
 * str2e
 * @param s
 * @param x
 */
function str2e(s, x) {
    return x[s];
}
/**
 * getPassword
 * @param length
 */
function getPassword(length) {
    var characterSet = 'abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789';
    return range(length).map(function () { return characterSet.charAt(Math.random() * characterSet.length); }).join('');
}
/**
 * Parse number status.
 * @param numberString String containing number.
 * @return NumberStatus represented by string.
 */
function parseNumberStatus(numberString) {
    if (numberString == null) {
        return { key: 'empty' };
    }
    var num = parseFloat(numberString);
    return !isNaN(num) ? { key: 'ok', value: num } : { key: 'error' };
}
/**
 * Compare arrays.
 * @param a1
 * @param a2
 * @param compare Optional compare function.
 * @return True if arrays equal when elements compared using compare function.
 */
function arraysEqual(a1, a2, compare) {
    var finalCompare = compare != null ? compare : function (e1, e2) { return e1 == e2; };
    return a1.length == a2.length && a1.every(function (e1) { return a2.some(function (e2) { return finalCompare(e1, e2); }); });
}
/**
 * Compare dates.
 * @param d1
 * @param d2
 * @return True if dates equal.
 */
function compareDates(d1, d2) {
    return d1.getTime() == d2.getTime();
}
/**
 * download
 * @param filename
 * @param text
 */
function download(filename, text) {
    var element = document.createElement('a');
    element.setAttribute('href', 'data:application/json;,' + encodeURIComponent(text));
    element.setAttribute('download', filename);
    element.style.display = 'none';
    document.body.appendChild(element);
    element.click();
    document.body.removeChild(element);
}
function downloadType(filename, text, format) {
    var element = document.createElement('a');
    var value = 'data:application/json;,';
    switch (format) {
        case ReportMixin_1.FormatType.csv:
            value = 'data:application/zip;,';
        case ReportMixin_1.FormatType.xml:
            value = 'data:application/xml;,';
        case ReportMixin_1.FormatType.excel:
            value = 'data:application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;,';
        case ReportMixin_1.FormatType.keyValue:
            value = 'data:text/plain;,';
        case ReportMixin_1.FormatType.yaml:
            value = 'data:application/yaml;,';
        default:
            value = 'data:application/json;,';
    }
    element.setAttribute('href', value + encodeURIComponent(text));
    element.setAttribute('download', filename);
    element.style.display = 'none';
    document.body.appendChild(element);
    element.click();
    document.body.removeChild(element);
}
//# sourceMappingURL=helper.js.map